import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-af994918"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "google-code-modal"
};
const _hoisted_2 = {
  class: "modal-title"
};
const _hoisted_3 = {
  class: "modal-desc"
};
const _hoisted_4 = {
  class: "btn-area"
};
import { nextTick, ref, watch } from 'vue';
import { useI18n } from 'vue-i18n';
export default {
  __name: 'GoogleCodeModal',
  props: {
    show: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  emits: ['hide', 'confirm'],
  setup(__props, {
    emit
  }) {
    const props = __props;
    const {
      t
    } = useI18n();
    const code = ref('');
    const codeInput = ref(null);
    const text = (key, fallback) => {
      const value = t(key);
      return value === key ? fallback : value;
    };
    const handleInput = event => {
      code.value = event.target.value.replace(/\D/g, '').slice(0, 6);
    };
    const close = () => {
      if (!props.loading) emit('hide');
    };
    const submit = () => {
      if (code.value.length === 6 && !props.loading) {
        emit('confirm', code.value);
      }
    };
    watch(() => props.show, show => {
      if (show) {
        code.value = '';
        nextTick(() => codeInput.value?.focus?.());
      }
    });
    return (_ctx, _cache) => {
      const _component_a_input = _resolveComponent("a-input");
      const _component_a_button = _resolveComponent("a-button");
      const _component_a_modal = _resolveComponent("a-modal");
      return _openBlock(), _createBlock(_component_a_modal, {
        visible: props.show,
        footer: null,
        closable: false,
        centered: "",
        width: "400px",
        onCancel: close
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, _toDisplayString(text('googleAuthCodeTitle', 'Google verification')), 1), _createElementVNode("div", _hoisted_3, _toDisplayString(text('googleAuthCodeDesc', 'Enter the 6-digit code from Google Authenticator.')), 1), _createVNode(_component_a_input, {
          ref_key: "codeInput",
          ref: codeInput,
          value: code.value,
          "onUpdate:value": _cache[0] || (_cache[0] = $event => code.value = $event),
          class: "code-input",
          type: "tel",
          inputmode: "numeric",
          maxlength: "6",
          placeholder: text('googleAuthCodeInput', 'Enter Google verification code'),
          allowClear: "",
          onInput: handleInput,
          onPressEnter: submit
        }, null, 8, ["value", "placeholder"]), _createElementVNode("div", _hoisted_4, [_createVNode(_component_a_button, {
          block: "",
          class: "cancel-btn",
          onClick: close
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(t)('cancelText')), 1)]),
          _: 1
        }), _createVNode(_component_a_button, {
          type: "primary",
          block: "",
          class: "confirm-btn",
          loading: props.loading,
          disabled: code.value.length !== 6,
          onClick: submit
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(t)('confirmText')), 1)]),
          _: 1
        }, 8, ["loading", "disabled"])])])]),
        _: 1
      }, 8, ["visible"]);
    };
  }
};